import axios from 'axios'

const request = axios.create({
  //axios config here
})


export default {
  methods: {
    //returns the axios request helper
    getRequest(){
      return request
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/request.js